import { Link } from 'react-router-dom';

import {
  ArrowNarrowRight,
  FacebookF,
  Github,
  Lightning,
  Twitter,
} from '../icons';

import { footerNavList } from '../copies';

const Footer = () => (
  <footer className="px-6 md:px-10 bg-gray-100 dark:bg-gray-900 dark:text-white">
    <div className="container max-w-screen-xl mx-auto">
      {/* CTA card */}
      <div className="p-8 sm:p-12 bg-gradient-to-br from-secondary-500 to-primary-600 text-white rounded-md flex flex-col md:flex-row md:items-center space-y-6 md:space-y-0 md:space-x-12 transform -translate-y-24">
        <div>
          <p className="text-4xl font-semibold mb-4">Ready to get started?</p>
          <p className="text-lg">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Incidunt
            optio officiis dolore earum error eaque perferendis laudantium sed
            praesentium dolorum.
          </p>
        </div>
        <div>
          <button className="py-4 px-8 rounded-md bg-white hover:bg-gray-100 text-primary-600 uppercase text-sm tracking-wide font-semibold focus:outline-none focus:ring-4 focus:ring-white focus:ring-opacity-50 shadow-lg flex items-center justify-center whitespace-nowrap w-full">
            <Lightning className="w-6 h-6 mr-1 flex-shrink-0" />
            Get started
          </button>
        </div>
      </div>

      {/* Footer's content */}
      <div>
        <div className="pb-12 space-y-12 lg:space-y-0 lg:grid lg:grid-cols-12 lg:gap-x-4">
          {/* Navigation */}
          <div className="space-y-12 sm:space-y-0 sm:grid grid-flow-col lg:col-span-8">
            {footerNavList.map(item => (
              <div className="space-y-4" key={item.label}>
                <p className="font-medium tracking-wider text-gray-400 uppercase">
                  {item.label}
                </p>
                <ul className="space-y-4">
                  {item.links.map(({ label, url }) => (
                    <li key={label}>
                      <Link
                        to={url}
                        className="opacity-50 hover:opacity-100 transition-opacity"
                      >
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Newsletter */}
          <div className="lg:col-span-4 space-y-4">
            <p className="font-medium tracking-wider text-gray-400 uppercase">
              Subscribe to our newsletter
            </p>
            <p className="opacity-50">
              Get the latest news and articles sent to your inbox every week.
            </p>
            <form className="relative flex items-center max-w-sm">
              <input
                type="email"
                required
                placeholder="Your email"
                className="w-full focus:outline-none border-gray-300 rounded-md p-4 pl-4 pr-14 truncate"
              />
              <button className="flex-shrink-0 absolute right-0 border-l focus:outline-none text-black focus:text-primary-600">
                <ArrowNarrowRight className="w-6 h-6 mx-4 opacity-50 hover:opacity-100 transition-opacity" />
              </button>
            </form>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between py-8 border-t border-gray-300">
          <a
            className="order-last sm:order-first text-center opacity-50"
            href="https://alterclass.io/courses/react"
            target="_blank"
            rel="noopener noreferrer"
          >
            © {new Date().getFullYear()} AlterClass. All rights reserved.
          </a>

          {/* Social icons */}
          <ul className="flex justify-center items-center space-x-2 mb-4 sm:mb-0 sm:ml-8">
            {/* Twitter */}
            <li className="opacity-50 hover:opacity-100 transition-opacity">
              <a href="#0" aria-label="Twitter">
                <Twitter className="w-10 h-10" />
              </a>
            </li>

            {/* Github */}
            <li className="opacity-50 hover:opacity-100 transition-opacity">
              <a href="#0" aria-label="Github">
                <Github className="w-10 h-10" />
              </a>
            </li>

            {/* Facebook */}
            <li className="opacity-50 hover:opacity-100 transition-opacity ">
              <a href="#0" aria-label="Facebook">
                <FacebookF className="w-10 h-10" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
